export const OPERATOR_MARKET_ROUTES = [
  "/markets",
  "/markets/live-prices",
  "/markets/calculator",
  "/markets/charts",
  "/markets/ratios",
  "/markets/history",
  "/markets/converter",
  "/markets/dealer-calculator",
  "/markets/alerts",
  "/markets/settings",
  "/markets/help",
  "/markets/overlay-studio/editor",
  "/markets/overlay-studio",
] as const;

export type MarketRouteSurface = "operator" | "public" | null;

export function resolveMarketRouteSurface(pathname: string): MarketRouteSurface {
  if (OPERATOR_MARKET_ROUTES.some((route) => pathname === route)) {
    return "operator";
  }
  return /^\/markets\/[^/]+\/?$/.test(pathname) ? "public" : null;
}